module.exports = __webpack_public_path__ + "static/media/male_back.25550e9a.jpg";